export default {
  namespaced: true,
  state: {
    id: null,
    email: null,
    affiliate: null,
    lastLogin: null,
    moduleCompletion: null
  },
  actions: {

  },
  mutations: {
    reset (state) {
      state.id = null,
      state.email = null,
      state.affiliate = null,
      state.lastLogin = null,
      state.moduleCompletion = null
    },
    set (state, payload) {
      state.id = payload.id
      state.email = payload.email
      state.affiliate = payload.affiliate
      state.lastLogin = payload.lastLogin
      state.moduleCompletion = payload.moduleCompletion
    },
    set_infos (state, payload) {
      state.moduleCompletion = payload.moduleCompletion
    },
    set_score(state, payload) {
      var updated = false
      for (var i = 0; i < state.moduleCompletion.length; i++) {
        var _module = state.moduleCompletion[i]
        if (_module.id === payload.idModule) {
          _module.latestScore = payload.score
          _module.NumberOfAttempt = _module.NumberOfAttempt + 1
          updated = true
        }
      }
      if (!updated) {
        state.moduleCompletion.push({
          idModule: payload.idModule,
          latestScore: payload.score,
          NumberOfAttempt: 1
        })
      }
    }
  },
  getters: {
    email: state => state.email,
    lastLogin: state => state.lastLogin,
    moduleCompletion: state => state.moduleCompletion
  }
}